import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Journey, SelectAppointment } from '../../../shared/types/strings.type';
import { StringsService } from '../../../shared/services/strings/strings.service';
import { ErrorService } from '../../../shared/services/errors/error.service';
import { DatesService } from '../../../shared/services/dates/dates.service';
import { environment } from '../../../../environments/environment';
import { AppSettings } from '../../../shared/PRE-LOAD/app-settings';
import { UserSelectionsService } from '../../../shared/services/user-selections/user-selections.service';
import { Utilities } from '../../../shared/utilities/utilities';
import { AnalyticsService } from '../../../shared/services/analytics/analytics.service';

@Component({
    selector: 'rttd-select-appointment',
    templateUrl: './select-appointment.component.html',
    styleUrls: [
        require('./select-appointment.component.scss').default.toString(),
        require(`./select-appointment.component.${environment.brand}.scss`).default.toString()
    ]
})
export class SelectAppointmentComponent implements OnInit {


    @ViewChild('locationForm', {static: false}) locationForm;

    modelPreferences = '';
    content: SelectAppointment;
    showSubmit: boolean;
    allowOffsite = this.appSettings.allowOffSite;
    isOffsite = this.userSelectionsService.get('startLocation') === this.utilities.startLocationAsString('off');

    header: Journey = {
        title: 'Book a Test Drive.',
        instruction: 'Arrange your test drive experience.'
    };

    constructor(
        public appSettings: AppSettings,
        private router: Router,
        private stringsService: StringsService,
        private datesService: DatesService,
        private errorService: ErrorService,
        private userSelectionsService: UserSelectionsService,
        private utilities: Utilities,
        private analytics: AnalyticsService) {
    }

    ngOnInit() {
        this.stringsService.get().subscribe((data: SelectAppointment) => {
            this.content = data['SelectAppointment'];
        });

        this.analytics.setRttdForm('Select Appointment');

    }   

    proceed() {

        this.analytics.setTestDrive(this.userSelectionsService.get('startTime'))

        if (this.isOffsite) {
            if (this.locationForm.detailsForm.valid) {
                this.userSelectionsService.set('startLocation', this.utilities.startLocationAsString('off'));
                this.router.navigate(['personal-information'], {skipLocationChange: true, fragment:'rttd'});
            } else {
                this.locationForm.detailsForm.markAllAsTouched();
            }
        } else {
            this.userSelectionsService.set('startLocation', this.utilities.startLocationAsString('on'));
            this.router.navigate(['personal-information'], {skipLocationChange: true, fragment:'rttd'});
        }
    }

    isOffSite($event: boolean) {
        this.isOffsite = $event;
    }

    currentDayCount($event) {
        this.showSubmit = $event.days > 1;
    }
}
